import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';

import { ProductsEffectsModule } from '@appStore/products/effects';
import { reducers } from '@appStore/products/reducers';
import * as fromServices from '@appStore/products/services';

export * from '@appStore/products/reducers';
export * from '@appStore/products/effects';
export * from '@appStore/products/actions';

@NgModule({
  imports: [CommonModule, StoreModule.forFeature('products', reducers), ProductsEffectsModule],
  providers: [...fromServices.services]
})
export class ProductsStoreModule {}
